import { TabProps } from '@mui/material'
import useGetLocatorDeliveryMethodTemplate
  from '~/src/components/locator/locator-filters/locator-delivery-filter-methods/locator-delivery-filter-method/styles/useGetLocatorDeliveryMethodTemplate'
import Tab from '~/src/components/mui-wrappers/styled/tab'
import { useTranslations } from '~/src/hooks/useTranslations'

interface Props extends TabProps {
  value: string,
  displayDisabledDeliveryMethod: boolean,
  disabled: boolean,
}

const LocatorDeliveryFilterMethod = ({ displayDisabledDeliveryMethod, disabled, value, ...otherProps }: Props) => {
  const styles = useGetLocatorDeliveryMethodTemplate()
  const { t } = useTranslations()

  if (!displayDisabledDeliveryMethod && disabled) {
    return null
  }

  return (
    <Tab
      value={value}
      disabled={disabled}
      label={t(`locator.filters.${value}`)}
      sx={styles.getTabSx()}
      {...otherProps}
    />
  )
}

export default LocatorDeliveryFilterMethod
